import React from 'react';
import { Interfaces, } from '../../../config';
import { TreeItems, } from './TreeItems';
import { TreeItem, } from '@mui/lab';
import { emptyTable, } from '../helpers';

const RenderTree = ({
  modelName,
  groupedTables,
  handleTableSelect,
  handleDeleteTable,
  handleDeleteSchema,
}: {
  modelName: string;
  groupedTables: Interfaces.ModelSchema;
  // eslint-disable-next-line no-unused-vars
  handleTableSelect: (table: Interfaces.ModelTable) => void;
  // eslint-disable-next-line no-unused-vars
  handleDeleteTable: (table: Interfaces.ModelTable) => void;
  // eslint-disable-next-line no-unused-vars
  handleDeleteSchema: (schema: string) => void;
}) => {
  return (
    <>
      {
        Object.keys(groupedTables).map((schema) => (
          <TreeItem
            key={`${modelName}.${schema || 'tables'}`}
            nodeId={`${modelName}.${schema || 'tables'}`}
            label={
              <TreeItems.Schema
                label={schema || 'tables'}
                handleAddTable={() => handleTableSelect({
                  ...emptyTable,
                  schema: schema,
                })}
                handleDeleteSchema={() => handleDeleteSchema(schema)}
              />
            }
          >
            {
              groupedTables[schema].map((table: Interfaces.ModelTable) => (
                <TreeItem
                  key={`${modelName}.${table._uuid}`}
                  nodeId={`${modelName}.${table._uuid}`}
                  label={
                    <TreeItems.Table
                      label={table.name}
                      handleDelete={() => handleDeleteTable(table)}
                    />
                  }
                  onClick={() => handleTableSelect(table)}
                >
                  {
                    table.columns.map((column) => (
                      <TreeItem
                        key={`${modelName}.${table.name}.${column._uuid}`}
                        nodeId={`${modelName}.${table.name}.${column._uuid}`}
                        label={<TreeItems.Column label={column.name}/>}
                        onClick={() => handleTableSelect(table)}
                      />
                    ))
                  }
                </TreeItem>
              ))
            }
          </TreeItem>
        ))
      }
    </>
  );
};

export { RenderTree, };
